module.exports = __webpack_public_path__ + "img/liucheng3.62b2a2d5.png";